import { render, staticRenderFns } from "./totalAll.vue?vue&type=template&id=10fa92a4&scoped=true&"
import script from "./totalAll.vue?vue&type=script&lang=js&"
export * from "./totalAll.vue?vue&type=script&lang=js&"
import style0 from "./totalAll.vue?vue&type=style&index=0&id=10fa92a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa92a4",
  null
  
)

export default component.exports